import { module } from 'modujs';
import gsap from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
        this.covers = document.querySelector('.home-covers');
    }

    init() {
        this.el.querySelectorAll('.home-list_item').forEach((item) => {
            item.addEventListener('mouseenter', () => {
                let projectId = item.getAttribute('data-project-id');
                this.covers.querySelector('.home-cover[data-project-id="' + projectId + '"]').classList.add('-active');
            });
            item.addEventListener('mouseleave', () => {
                let projectId = item.getAttribute('data-project-id');
                this.covers.querySelector('.home-cover[data-project-id="' + projectId + '"]').classList.remove('-active');
            });
        });
    }

    animateSplit(data) {
        let chars = data.target?.querySelectorAll('.char');
        if (chars) {
            gsap.to(chars, {
                y: 0,
                duration: 0.8,
                ease: 'power4.out',
                stagger: {each: 0.02, from: 'random'}
            });
        }
    }
}
